import { forwardRef, useContext } from 'react';
import { PlusSecondIcon } from 'nexticons/outline';
import { MenuContext } from 'contexts/MenuProvider';
import './OffersCategory.css';

const OffersCategory = forwardRef(({ category, onClickOfferHandler }, ref) => {
  const { mappedSelectedMenuItemQuantities } = useContext(MenuContext);

  return (
    <div ref={ref} className='offersCategory'>
      {category.sections.map((section) => (
        <section key={section.key} className='offersSection'>
          <h2 className='offersSection__heading'>{section.heading}</h2>
          {section.subHeading && (
            <p className='offersSection__subHeading'>{section.subHeading}</p>
          )}
          <div className='offersSection__carousel'>
            {section.items.map((item) => {
              const count = item.menuItemId
                ? mappedSelectedMenuItemQuantities?.[item.menuItemId]
                : 0;
              return (
                <button
                  type='button'
                  key={item.key}
                  className='offerCard'
                  onClick={() =>
                    onClickOfferHandler?.({
                      voucherId: item.voucherId,
                      menuItemId: item.menuItemId,
                    })
                  }
                >
                  <div className='offerCard__media'>
                    {item.imgSrc && (
                      <img
                        className='offerCard__img'
                        src={item.imgSrc}
                        alt={item.name}
                        loading='lazy'
                      />
                    )}
                    {item.badge && (
                      <span
                        className={`offerCard__badge${
                          item.menuItemId ? ' offerCard__badge--withAdd' : ''
                        }`}
                      >
                        {item.badge}
                      </span>
                    )}
                    {item.menuItemId && (
                      <span className='absolute right-2 top-2 z-3 inline-flex h-7.5 w-7.5 items-center justify-center rounded-full bg-white shadow-cw-second xl:h-8 xl:w-8 2xl:right-2.25 2xl:top-2.25 2xl:h-9 2xl:w-9'>
                        {count ? (
                          <span className='text-xl font-semibold leading-5'>
                            {count}
                          </span>
                        ) : (
                          <PlusSecondIcon
                            strokeWidth={3.5}
                            className='w-4 xl:w-4.5 xl:stroke-3 2xl:w-5 2xl:stroke-3.25'
                          />
                        )}
                      </span>
                    )}
                    <div className='offerCard__overlay'>
                      {item.priceBadge && (
                        <span className='offerCard__price'>
                          {item.priceBadge}
                        </span>
                      )}
                      <span className='offerCard__name'>{item.name}</span>
                    </div>
                  </div>
                  {item.subHeading !== undefined ? (
                    <p className='offerCard__desc offerCard__desc--fixed'>
                      {item.subHeading}
                    </p>
                  ) : (
                    item.description && (
                      <p className='offerCard__desc'>{item.description}</p>
                    )
                  )}
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
});

export default OffersCategory;
